/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EventMini.vue?vue&type=template&id=4ee502e2&scoped=true"
import script from "./EventMini.ts?vue&type=script&lang=ts&external"
export * from "./EventMini.ts?vue&type=script&lang=ts&external"
import style0 from "./EventMini.vue?vue&type=style&index=0&id=4ee502e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee502e2",
  null
  
)

export default component.exports